import { CAPTCHA_EXEMPT_COUNTRIES } from '@/constants/captcha';
import type { CountryCodeEnum } from '@/enums/country-code-enum';
import { getUserCountryCode } from '@/utils/get-user-country-code';

// Predicado puro: o país informado está isento de CAPTCHA? (SCRUM-1576)
export function isCaptchaExemptCountry(countryCode: CountryCodeEnum): boolean {
  return CAPTCHA_EXEMPT_COUNTRIES.includes(countryCode);
}

// Versão não-reativa (snapshot único do país) — útil fora de componentes.
export function shouldBypassCaptcha(): boolean {
  return isCaptchaExemptCountry(getUserCountryCode());
}
